import { useState } from 'react'

import { Button } from '@/components/ui/button.tsx'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog.tsx'

type Props = {
  attachment: Attachment
  onRemove: () => void
  progress?: number
}

export const AttachmentDeleteButton = ({ attachment, progress, onRemove }: Props) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        type="button"
        aria-label="Delete attachment"
        variant="ghost"
        size="icon"
        onClick={() => {
          progress ? onRemove() : setOpen(true) // Not sure, why the dialog does not show up during progress
        }}
      >
        <img src="/images/file-delete-icon.svg" alt="delete-icon" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="p-4 gap-6 [&>button]:hidden">
          <DialogHeader>
            <DialogTitle className="font-EN-KR-sub-heading-bold text-contents-primary">Delete Attachment?</DialogTitle>
            <DialogDescription className="font-EN-KR-body1-regular text-contents-primary">
              Are you sure you want to delete '{attachment.filename}'?
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="secondary" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={() => {
                onRemove()
                setOpen(false)
              }}
            >
              Delete
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
